import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useProjectAccessCtx } from 'src/features/projects/ProjectAccessContext';
import { hasPerm } from 'src/features/projects/hooks/useProjectAccess';
import { useProject } from 'src/features/projects/hooks/useProject';
import WbsInternalProgressEntryContainer from './WbsInternalProgressEntryContainer';

export default function WbsInternalProgressEntryPage() {
    const { projectId } = useParams<{ projectId: string }>();
    const { access, isLoading: accessLoading } = useProjectAccessCtx();
    const { data: projectRes } = useProject(projectId as string);

    if (!projectId?.trim()) {
        return <div className="p-6 text-sm text-rose-700">잘못된 프로젝트 ID 입니다.</div>;
    }

    if (accessLoading) {
        return <div className="p-6 text-sm text-gray-500">프로젝트 접근 권한 확인 중…</div>;
    }

    const canEvEntry = hasPerm(access?.permissions, 'wbs.ev.entry');
    if (!canEvEntry || access?.isExternalProjectCompanyUser === true) {
        return <Navigate to={`/projects/${projectId}/wbs`} replace />;
    }

    const projectName = projectRes?.data?.name ?? 'Project';

    return (
        <div className="space-y-4">
            <div className="w-full flex justify-between items-start gap-4">
                <div>
                    <h1 className="text-lg font-semibold">Internal Weekly Progress Entry</h1>
                    <p className="text-sm text-gray-600">{projectName}</p>
                    <p className="text-xs text-gray-500">전체 WBS를 확인하고, 내 ORG에 배정된 leaf만 입력할 수 있습니다.</p>
                </div>
                <Link to={`/projects/${projectId}/wbs`}>
                    <button type="button" className="rounded border px-3 py-1 text-xs hover:bg-gray-50">
                        WBS로 돌아가기
                    </button>
                </Link>
            </div>

            <WbsInternalProgressEntryContainer projectId={projectId} />
        </div>
    );
}
